import React from "react";
import HeroVariant1 from "../components/Hero/Variant1";
import HeroVariant2 from "../components/Hero/Variant2";
import HeroVariant3 from "../components/Hero/Variant3";
import HeroVariant4 from "../components/Hero/Variant4";

export const hero_library = {
  hero: {
    variant1: {
      name: "Hero Split",
      description: "Hero with image and text side by side.",
      Component: React.memo(HeroVariant1),
      metadata: {
        tokens: {
          heading: { type: "text", default: "Modern Web Solutions" },
          subheading: {
            type: "text",
            default: "Build amazing digital experiences...",
          },
          primaryButton: { type: "text", default: "Get Started" },
          secondaryButton: { type: "text", default: "Live Demo" },
        },
      },
    },
    variant2: {
      name: "Centered Hero",
      description: "Centered content with call to action.",
      Component: React.memo(HeroVariant2),
      metadata: {
        tokens: {
          heading: { type: "text", default: "Transform Your Digital Presence" },
          subheading: {
            type: "text",
            default:
              "Enterprise-grade solutions for modern businesses. Scale effortlessly with our intuitive platform.",
          },
          primaryButton: { type: "text", default: "Start free Trial" },
          imagePlaceholder: { type: "text", default: "Hero Image" },
        },
      },
    },
    variant3: {
      name: "Full Width Hero",
      description: "Full width hero with background image.",
      Component: React.memo(HeroVariant3),
      metadata: {
        tokens: {
          heading: {
            type: "text",
            default: "Drive Innovation with Our Platform",
          },
          subheading: {
            type: "text",
            default:
              "Create, scale, and optimize digital experiences that delight users and grow businesses.",
          },
          primaryButton: { type: "text", default: "Learn More" },
          secondaryButton: { type: "text", default: "Contact Sales" },
          imagePlaceholder: { type: "text", default: "Illustration Here" },
        },
      },
    },
    variant4: {
      name: "Overlay Hero",
      description: "Hero with overlay text on image.",
      Component: React.memo(HeroVariant4),
      metadata: {
        tokens: {
          heading: { type: "text", default: "Unlock Limitless Possibilities" },
          subheading: {
            type: "text",
            default:
              "From startups to enterprises, our tools empower you to build fast and scale smart.",
          },
          primaryButton: { type: "text", default: "Join the Revolution" },
        },
      },
    },
  },
};
